import classNames from 'classnames';
import React from 'react';

import {Tracker, TrackImpression, ClickEvent} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {StepCard} from '@udemy/react-certification-preparation';
import {Button} from '@udemy/react-core-components';

import defaultStyles from './academies-steps.module.less';
import {AcademyCourseSummaryPresented} from './events';

interface AcademiesStepsProps {
    id: string;
    slug: string;
    number?: number;
    title: string;
    description: string;
    curriculumId: string;
    styles?: typeof defaultStyles;
}

export const AcademiesSteps = ({
    id,
    slug,
    number,
    title,
    description,
    curriculumId,
    styles = defaultStyles,
}: AcademiesStepsProps) => {
    const {gettext} = useI18n();

    const trackView = () => {
        Tracker.publishEvent(
            new AcademyCourseSummaryPresented({academySlug: slug, courseId: parseInt(id)}),
        );
    };

    const trackClick = () => {
        Tracker.publishEvent(
            new ClickEvent({
                componentName: 'academyCourseContentLink',
                relatedObjectType: 'course',
                relatedObjectId: parseInt(id),
            }),
        );
    };

    const onContentClick = () => {
        const element = document.getElementById(curriculumId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
        trackClick();
    };

    return (
        <TrackImpression trackFunc={trackView}>
            <div>
                <StepCard number={number ?? 1} title={title} description={description}>
                    <Button
                        componentClass="button"
                        className={classNames(styles['content-link'], 'ud-text-bold')}
                        udStyle="link"
                        onClick={onContentClick}
                    >
                        {gettext('Course content')}
                        <Icon
                            glyph="next"
                            size="small"
                            label="Course content"
                            className={classNames(styles['next-icon'])}
                        />
                    </Button>
                </StepCard>
            </div>
        </TrackImpression>
    );
};
